module.exports = __webpack_public_path__ + "static/prebuilt_cycling_plans-46745ee86bcfd558aebefb532eea4600.jpg";